import * as React from "react";
import { connect } from "react-redux";
import { selectLastModalId } from "../../selectors/selectModalTabId";
import { selectIsTutorialActive } from "../../selectors/selectTutorial";
import { Key } from "../generic/key-handler/Key";
import { KeyEventType } from "../generic/key-handler/KeyEventType";
import { StackedKeyHandler } from "../generic/key-handler/StackedKeyHandler";
import { actionModalCloseLast } from "./actionModal";
import { TypeOverlayOpacity } from "./TypeOverlayOpacity";
var ModalOverlayDOM = function (_a) {
    var _b = _a.allowClick, allowClick = _b === void 0 ? true : _b, closeLastModal = _a.closeLastModal, lastModalId = _a.lastModalId, isTutorialActive = _a.isTutorialActive, children = _a.children, onCloseOverride = _a.onCloseOverride, _c = _a.opacityType, opacityType = _c === void 0 ? TypeOverlayOpacity.Light : _c;
    var curriedOnClose = function () {
        return handleOnClose(lastModalId, isTutorialActive, closeLastModal, onCloseOverride);
    };
    var handleOnClick = function (event) {
        if (allowClick) {
            handleClick(event, curriedOnClose);
        }
    };
    // We need to use the StackedKeyHandler in order not to have issues closing modals when we press Escape.
    // If you try replacing it with the regular KeyHandler It will not close all the modal you'll notice only
    // the first escape happens. If you manage to stack 3 modals you will notice two modals will close.
    // [1,2] => esc 1 fires, closes modal 2. modal 2 Is closed, hence esc is not fired.
    // [1,2,3] => esc 1 fires, closes modal 3 => [1,2] => esc 2 fires, closes modal 2.
    return (React.createElement("div", { className: "modal-wrapper" },
        React.createElement("div", { className: "modal-overlay " + opacityType, onClick: handleOnClick },
            React.createElement(StackedKeyHandler, { keyCode: Key.Escape, keyEventType: KeyEventType.Keyup, handler: curriedOnClose })),
        children));
};
var handleClick = function (event, onClose) {
    if (event.currentTarget !== event.target) {
        return;
    }
    event.stopPropagation();
    onClose();
};
var handleOnClose = function (modalId, isTutorialActive, closeLastModal, onCloseOverride) {
    if (isTutorialActive) {
        return;
    }
    if (onCloseOverride) {
        onCloseOverride();
    }
    else {
        closeLastModal(modalId);
    }
};
var mapState = function (state) { return ({
    isTutorialActive: selectIsTutorialActive(state),
    lastModalId: selectLastModalId(state),
}); };
var mapDispatch = function (dispatch) { return ({
    closeLastModal: function (lastModalId) { return dispatch(actionModalCloseLast(lastModalId)); },
}); };
export var ModalOverlay = connect(mapState, mapDispatch)(ModalOverlayDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/modals/ModalOverlay.tsx
// module id = 267
// module chunks = 3